/**
 * Single inventory signal row for Tietopohja IA.
 * Komponentit · Laitteen taso · Riippuvuudet feed `KbSignalRowModel`.
 */
import type { KbSignalRowModel } from "@/lib/kb-ia";
import { cardTonePill } from "@/lib/card-styles";
import { cn } from "@/lib/utils";

function idChipClass(model: KbSignalRowModel): string {
  if (model.emphasis === "interface" || model.emphasis === "neutral") {
    return "border-border bg-muted/40 text-muted-foreground";
  }
  if (model.criticality === "required") {
    return "border-rose-500/30 bg-rose-500/5 text-rose-400";
  }
  if (model.criticality === "recommended") {
    return "border-warning/30 bg-warning-subtle text-warning-subtle-foreground";
  }
  return "border-border bg-muted/40 text-muted-foreground";
}

export function KbSignalRow({ model }: { model: KbSignalRowModel }) {
  return (
    <div className="flex items-baseline gap-2 flex-wrap py-0.5">
      <span
        className={cn(
          "rounded px-1.5 py-0.5 text-[10px] font-mono border",
          idChipClass(model),
        )}
      >
        {model.id}
      </span>
      <span className="text-[11px] text-foreground/90">{model.name_fi}</span>
      {model.unit ? (
        <span className="text-[10px] text-muted-foreground">{model.unit}</span>
      ) : null}
      {model.meta_fi ? (
        <span
          className={cn(
            "shrink-0 rounded-full border px-1.5 py-0.5 text-[9px] font-medium leading-none",
            cardTonePill.empty,
          )}
          title={model.meta_title}
        >
          {model.meta_fi}
        </span>
      ) : null}
      {model.note_fi ? (
        <span className="basis-full text-[10px] text-muted-foreground leading-relaxed pl-0.5">
          {model.note_fi}
        </span>
      ) : null}
    </div>
  );
}
